import { Auth0Provider } from '@auth0/auth0-react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '@/features/auth';
import { NotificationProvider } from '@/features/notifications';
import { ThemeProvider } from '@/shared/theme';
import { FullScreenLoaderProvider } from '@/shared/ui';
import { config } from '@config';
import { ErrorBoundaryWrapper } from './ErrorBoundaryWrapper';
import { Routes } from './Routes';
import { SocketProvider } from '../api';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      useErrorBoundary: true,
    },
  },
});

export const App = () => {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <Auth0Provider
          {...config.auth0}
          authorizationParams={{
            redirect_uri: window.location.origin,
            audience: config.auth0.audience,
          }}
          cacheLocation="localstorage"
          useRefreshTokens={true}
          useRefreshTokensFallback={true}
        >
          <QueryClientProvider client={queryClient}>
            <FullScreenLoaderProvider>
              <AuthProvider>
                <SocketProvider>
                  <NotificationProvider>
                    <DndProvider backend={HTML5Backend}>
                      <ErrorBoundaryWrapper>
                        <BrowserRouter>
                          <Routes />
                        </BrowserRouter>
                      </ErrorBoundaryWrapper>
                    </DndProvider>
                  </NotificationProvider>
                </SocketProvider>
              </AuthProvider>
            </FullScreenLoaderProvider>
          </QueryClientProvider>
        </Auth0Provider>
      </ThemeProvider>
    </HelmetProvider>
  );
};
